const KaplanAuth = {
  init() {
    if (!($('.kaplan-auth-callback').length > 0)) return;
    this.pushFragmentToQuery();
  },

  pushFragmentToQuery(event) {
    const newHref = location.href.replace('#', '?');
    if (newHref.indexOf('id_token=') !== -1) {
      window.location = newHref;
    } else {
      window.location = newHref.replace('callback', 'missing_id_token')
    }
  },
};

$(document).ready(()=> {
  KaplanAuth.init();
});
